import { Link } from 'react-router-dom';
import { ReactNode } from 'react';
import './button.scss';

interface ButtonProps {
  children: ReactNode;
  to?: string;
  href?: string;
  target?: string;
  rel?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'default' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  ariaLabel?: string;
  title?: string;
}

export function Button({ children, to, href, target, rel, onClick, type = 'button', variant = 'default', size = 'lg', className = '', ariaLabel, title }: ButtonProps) {
  const finalClassName = `button button--${variant} button--${size} ${className}`.trim();

  if (href) {
    return (
      <a href={href} target={target} rel={rel} className={finalClassName} onClick={onClick} aria-label={ariaLabel} title={title}>
        {children}
      </a>
    );
  }

  if (to) {
    return (
      <Link to={to} className={finalClassName} onClick={onClick} aria-label={ariaLabel} title={title}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} className={finalClassName} onClick={onClick} aria-label={ariaLabel} title={title}>
      {children}
    </button>
  );
}
